module.exports = __webpack_public_path__ + "static/media/HELI-CPD30-1.cb8771f0.jpg";